<template>
  <UiSectionWrapper
    title="Kirim Banyak Paket Sekaligus Hemat Waktu"
    sub-title="Kirim Paket Massal"
    description="Gratis digunakan, tanpa biaya setup. Cocok untuk seller dan brand dengan volume tinggi"
    hero-image="/images/kirim-paket-massal-banner-4.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
    button-label="Gunakan Kirim Massal"
    :button-link="
      $utm.utmUrl('/login', {
        redirectTo: '/packages/upload'
      })
    "
  />
</template>
